export const globals = {
  styles: {
    global: {
      'html, body': {
        height: 'full',
        overflow: 'hidden',
      },
      body: {
        fontSize: '12px',
        fontWeight: '400',
        lineHeight: '14.4px',
        letterSpacing: '0.2px',
        color: 'marketcast.text.primary',
        backgroundColor: 'marketcast.base.background',
      },
      // Force Volte on headings (the ui-kit theme defaults them to a serif),
      // matching the dashboard UI project.
      '.chakra-heading': {
        fontFamily: '"Volte", sans-serif !important',
      },
      '*':{
        scrollbarWidth: 'thin', 
        scrollbarColor: '#DAD9D6 #FAF9FA', 
      },
      '#root': {
        height: 'full',
      },
    },
  },
};
